import(/* webpackMode: "eager" */ "/var/www/html/web.frontend/releases/6/apps/cv-client/src/app/error.tsx");
